import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import {
  OptionItemSquare,
  OptionItemSquareList,
} from '@/pages/Onboarding/components/OptionItemSquare/OptionItemSquare';
import { useOnboarding } from '@/pages/Onboarding/context';
import { HAIR_COLOR_OPTIONS } from '@/pages/Onboarding/options/HairColor/HAIR_COLOR_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  OwnAiTitle,
  OwnAiTitleHighlight,
} from '../../../OwnAI/components/Title';
import { LayoutDataType } from '../../types';

import { ScreenHairColorStyles } from './HairColor.styles';

export const ScreenHairColor: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'HairColor',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const hairColor = form.watch('hair_color');

  const handleNextStep = () => {
    wizard.goToStep('body_shape');
  };

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['hair_color']>,
  ) => {
    form.setValue('hair_color', option.id);
    userService.createOrUpdate({
      onboarding_data: {
        hair_color: option.title,
      },
    });
    nextStepTimeout(handleNextStep);
  };

  const getImgSrc = (id: string) => {
    return `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai/hair_color/${id}.png`;
  };

  return (
    <ScreenHairColorStyles>
      <OnboardingNavigation />
      <OwnAiTitle>
        Select her <OwnAiTitleHighlight>hair color</OwnAiTitleHighlight>
      </OwnAiTitle>

      <IonContent>
        <OptionItemSquareList>
          {HAIR_COLOR_OPTIONS.map((option) => (
            <OptionItemSquare
              key={option.id}
              isSelected={hairColor === option.id}
              onClick={() => handleSelect(option)}
              bgSrc={getImgSrc(option.id)}
              title={option.title}
              TEST_ID={`hair_color-${option.id}`}
            />
          ))}
        </OptionItemSquareList>
      </IonContent>
    </ScreenHairColorStyles>
  );
};
